/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

console.log('[custom.js] loaded');

(function () {
  'use strict';

  // ── Desktop detection ─────────────────────────────────────────────────────
  // matchMedia('(hover: hover) and (pointer: fine)') is true only when the
  // primary input device is a real mouse — reliably excludes touch screens and
  // avoids the false-positive from 'ontouchstart' in window which Chrome
  // exposes on all platforms for DevTools emulation.
  function isHoverDevice() {
    return window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  }

  // ── Indicator tracking ────────────────────────────────────────────────────
  // Updates --slider-index on .product-item__image as the user navigates.
  // Works in two modes:
  //   Flickity mode : listens to Flickity 'change' events (when no-touch class
  //                   is correctly set and Flickity initialises)
  //   Scroll mode   : listens to scroll events on the slider container (when
  //                   supports-touch is incorrectly set on a desktop browser,
  //                   causing scroll-snap to be used instead of Flickity)
  //
  // --slides-count is already set as an inline style from Liquid, so it is
  // correct on first paint with no JS dependency.

  function setupIndicator(imageDiv) {
    if (imageDiv.dataset.pgiIndicator) return; // idempotency guard
    imageDiv.dataset.pgiIndicator = '1';

    var hoverImages = imageDiv.querySelector('hover-images');
    if (!hoverImages) return;
    var hoverSlides = hoverImages.querySelectorAll('[data-hover-slide]');
    if (hoverSlides.length === 0) return;

    // --slider-index is NOT set on init so the CSS fallback of 0 applies —
    // that shows the image-1 segment, which is correct because the static
    // layer always shows image 1 when the card is not being hovered.
    // On mouseleave we remove any inline value so it snaps back to 0.

    if (hoverImages.flkty) {
      // ── Flickity mode ──────────────────────────────────────────────────
      // Update while navigating with arrows.
      hoverImages.flkty.on('change', function (index) {
        imageDiv.style.setProperty('--slider-index', index + 1);
      });
      // Sync to current Flickity position when hover begins.
      imageDiv.addEventListener('mouseenter', function () {
        imageDiv.style.setProperty('--slider-index', hoverImages.flkty.selectedIndex + 1);
      });
      // Reset to image-1 segment when hover ends.
      imageDiv.addEventListener('mouseleave', function () {
        imageDiv.style.removeProperty('--slider-index');
      });
    } else {
      // ── Scroll mode ────────────────────────────────────────────────────
      // Flickity did not initialise (browser has supports-touch class set).
      // The hover-images element is a CSS scroll-snap container.
      var slider = hoverImages.querySelector('[data-hover-slider]');
      if (!slider) return;
      // Use ALL slides (including image 1 at index 0) so position tracking
      // and scrolling covers the full set.
      var allSlides = Array.from(hoverImages.querySelectorAll('[data-hover-slide-touch]'));
      if (allSlides.length === 0) allSlides = Array.from(hoverSlides); // fallback

      // First [data-hover-slide] = image 2 (the first hover-only slide)
      var firstHoverSlide = hoverImages.querySelector('[data-hover-slide]');
      var currentScrollIndex = 0;

      function syncScrollIndex() {
        var best = 0, bestDiff = Infinity;
        allSlides.forEach(function (slide, i) {
          var diff = Math.abs(slide.offsetLeft - slider.scrollLeft);
          if (diff < bestDiff) { bestDiff = diff; best = i; }
        });
        currentScrollIndex = best;
        // best is 0-based across ALL slides; segment 0 = image 1.
        imageDiv.style.setProperty('--slider-index', best);
      }

      // ── Wrap-around (infinite swipe) for scroll-snap ──────────────────
      // CSS scroll-snap has no built-in wrap; Flickity's wrapAround handles
      // desktop. Here we detect a boundary swipe (finger lifted while at the
      // first or last snap point) and after the animation settles we jump
      // instantly to the opposite end so the carousel feels infinite.
      var pendingWrap = 0; // -1 = wrap to first slide, 1 = wrap to last slide
      var wrapTimer   = null;
      var touchStartX = null;
      var idxAtTouch  = 0;

      if (allSlides.length >= 2) {
        hoverImages.addEventListener('touchstart', function (e) {
          clearTimeout(wrapTimer);
          touchStartX = e.touches[0].clientX;
          idxAtTouch  = currentScrollIndex;
          pendingWrap = 0;
        }, { passive: true });

        hoverImages.addEventListener('touchend', function (e) {
          if (touchStartX === null) return;
          var dx = e.changedTouches[0].clientX - touchStartX;
          touchStartX = null;
          if (Math.abs(dx) < 30) return; // not a real swipe
          if (dx < 0 && idxAtTouch === allSlides.length - 1) {
            pendingWrap = -1; // swiping left on last slide → wrap to first
          } else if (dx > 0 && idxAtTouch === 0) {
            pendingWrap = 1;  // swiping right on first slide → wrap to last
          }
          // Fallback: execute wrap if no scroll events fire (very short bounce)
          if (pendingWrap !== 0) {
            wrapTimer = setTimeout(function () {
              if (pendingWrap === 0) return;
              var pw = pendingWrap;
              pendingWrap = 0;
              var tgt = pw === -1 ? allSlides[0] : allSlides[allSlides.length - 1];
              slider.scrollTo({ left: tgt.offsetLeft, behavior: 'instant' });
            }, 380);
          }
        }, { passive: true });
      }

      slider.addEventListener('scroll', function () {
        syncScrollIndex();
        // After scroll settles (~200 ms of quiet), execute any pending wrap jump
        if (pendingWrap !== 0) {
          clearTimeout(wrapTimer);
          wrapTimer = setTimeout(function () {
            var pw = pendingWrap;
            pendingWrap = 0;
            var tgt = pw === -1 ? allSlides[0] : allSlides[allSlides.length - 1];
            slider.scrollTo({ left: tgt.offsetLeft, behavior: 'instant' });
          }, 200);
        }
      }, { passive: true });

      // On mouseenter: scroll to image 2 (first hover slide) so the hover
      // overlay starts at the correct position, then sync the indicator.
      imageDiv.addEventListener('mouseenter', function () {
        pendingWrap = 0;
        clearTimeout(wrapTimer);
        if (firstHoverSlide) {
          slider.scrollLeft = firstHoverSlide.offsetLeft;
        }
        syncScrollIndex();
      });
      // Reset to image-1 segment on mouseleave.
      imageDiv.addEventListener('mouseleave', function () {
        imageDiv.style.removeProperty('--slider-index');
      });
      // Do NOT call syncScrollIndex() here — let --slider-index default to 0.
    }
  }

  // ── Chevron arrow buttons (desktop hover devices) ────────────────────────
  // Works in two modes:
  //   Flickity mode  – hoverImages.flkty exists (Firefox/Safari desktop where
  //                    navigator.maxTouchPoints === 0 so the theme uses Flickity)
  //   Scroll mode    – no Flickity (Chrome desktop where maxTouchPoints > 0
  //                    makes window.theme.touch = true, so scroll-snap is used)
  // In both modes wrap-around is applied explicitly.

  function injectArrows(imageDiv) {
    if (imageDiv.querySelector('.pgi-card-arrow-layer')) return; // idempotency
    if (!imageDiv.classList.contains('double__image')) return;

    var hoverImages = imageDiv.querySelector('hover-images');
    if (!hoverImages) return;

    var flkty      = hoverImages.flkty || null;
    var snapSlider = null;
    var snapSlides = null;

    if (flkty) {
      // Flickity mode: need ≥ 2 hover-only cells (= 3+ image product)
      if (!flkty.slides || flkty.slides.length < 2) return;
    } else {
      // Scroll-snap mode: build slide list from DOM
      snapSlider = hoverImages.querySelector('[data-hover-slider]');
      if (!snapSlider) return;
      snapSlides = Array.from(hoverImages.querySelectorAll('[data-hover-slide-touch]'));
      if (snapSlides.length === 0) snapSlides = Array.from(hoverImages.querySelectorAll('[data-hover-slide]'));
      if (snapSlides.length < 2) return; // single image card — no arrows needed
    }

    function getSnapIdx() {
      var best = 0, bestDiff = Infinity;
      snapSlides.forEach(function (slide, i) {
        var diff = Math.abs(slide.offsetLeft - snapSlider.scrollLeft);
        if (diff < bestDiff) { bestDiff = diff; best = i; }
      });
      return best;
    }

    function navigate(dir) {
      if (flkty) {
        var total   = flkty.slides.length;
        var current = flkty.selectedIndex;
        flkty.select(dir === 'prev' ? (current === 0 ? total - 1 : current - 1)
                                    : (current === total - 1 ? 0 : current + 1));
      } else {
        var total   = snapSlides.length;
        var current = getSnapIdx();
        var target  = dir === 'prev' ? (current === 0 ? total - 1 : current - 1)
                                     : (current === total - 1 ? 0 : current + 1);
        snapSlider.scrollTo({ left: snapSlides[target].offsetLeft, behavior: 'smooth' });
      }
    }

    var left = document.createElement('button');
    left.className = 'pgi-card-arrow pgi-card-arrow--left';
    left.type = 'button';
    left.setAttribute('aria-label', 'Previous image');

    var right = document.createElement('button');
    right.className = 'pgi-card-arrow pgi-card-arrow--right';
    right.type = 'button';
    right.setAttribute('aria-label', 'Next image');

    left.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      navigate('prev');
    });

    right.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      navigate('next');
    });

    var layer = document.createElement('div');
    layer.className = 'pgi-card-arrow-layer';
    layer.appendChild(left);
    layer.appendChild(right);
    imageDiv.appendChild(layer);
  }

  // ── Per-card setup ────────────────────────────────────────────────────────
  // Tries to wait for Flickity. If Flickity never arrives (supports-touch mode)
  // falls back to scroll-based indicator tracking after the retry window.
  // Either way exactly one setupIndicator() call is made per card.

  function trySetupCard(imageDiv, attempts) {
    var hoverImages = imageDiv.querySelector('hover-images');
    if (hoverImages && hoverImages.flkty) {
      setupIndicator(imageDiv); // Flickity mode
      injectArrows(imageDiv);
    } else if (attempts < 10) {
      setTimeout(function () { trySetupCard(imageDiv, attempts + 1); }, 50);
    } else {
      setupIndicator(imageDiv); // scroll-snap mode fallback
      injectArrows(imageDiv);   // arrows work in scroll-snap mode too
    }
  }

  function initAll() {
    if (!isHoverDevice()) return;
    document.querySelectorAll('.product-item__image.double__image').forEach(function (div) {
      trySetupCard(div, 0);
    });
  }

  // ── Mobile swipe wrap-around ──────────────────────────────────────────────
  // initAll() never runs on real mobile phones (isHoverDevice() = false there).
  // setupMobileWrap is called independently so CSS scroll-snap carousels get
  // infinite-scroll wrap on touch devices, without affecting the desktop paths.
  function setupMobileWrap(imageDiv) {
    if (imageDiv.dataset.mobileWrap) return; // idempotency guard
    var hoverImages = imageDiv.querySelector('hover-images');
    if (!hoverImages) return;
    var slider = hoverImages.querySelector('[data-hover-slider]');
    if (!slider) return;
    var slides = Array.from(hoverImages.querySelectorAll('[data-hover-slide-touch]'));
    if (slides.length === 0) slides = Array.from(hoverImages.querySelectorAll('[data-hover-slide]'));
    if (slides.length < 2) return;
    imageDiv.dataset.mobileWrap = '1';

    var pendingWrap = 0; // -1 = wrap to first slide, 1 = wrap to last slide
    var wrapTimer   = null;
    var touchStartX = null;
    var idxAtTouch  = 0;

    function getIdx() {
      var best = 0, bestDiff = Infinity;
      slides.forEach(function (slide, i) {
        var diff = Math.abs(slide.offsetLeft - slider.scrollLeft);
        if (diff < bestDiff) { bestDiff = diff; best = i; }
      });
      return best;
    }

    function doWrap(pw) {
      var tgt = pw === -1 ? slides[0] : slides[slides.length - 1];
      slider.scrollTo({ left: tgt.offsetLeft, behavior: 'instant' });
    }

    hoverImages.addEventListener('touchstart', function (e) {
      clearTimeout(wrapTimer);
      touchStartX = e.touches[0].clientX;
      idxAtTouch  = getIdx();
      pendingWrap = 0;
    }, { passive: true });

    hoverImages.addEventListener('touchend', function (e) {
      if (touchStartX === null) return;
      var dx = e.changedTouches[0].clientX - touchStartX;
      touchStartX = null;
      if (Math.abs(dx) < 30) return; // not a real swipe
      if (dx < 0 && idxAtTouch === slides.length - 1) {
        pendingWrap = -1; // swiping left on last slide → wrap to first
      } else if (dx > 0 && idxAtTouch === 0) {
        pendingWrap = 1;  // swiping right on first slide → wrap to last
      }
      // Fallback: fire even if no scroll events occur (very short bounce)
      if (pendingWrap !== 0) {
        wrapTimer = setTimeout(function () {
          if (pendingWrap === 0) return;
          var pw = pendingWrap;
          pendingWrap = 0;
          doWrap(pw);
        }, 380);
      }
    }, { passive: true });

    slider.addEventListener('scroll', function () {
      if (pendingWrap === 0) return;
      clearTimeout(wrapTimer);
      wrapTimer = setTimeout(function () {
        var pw = pendingWrap;
        pendingWrap = 0;
        doWrap(pw);
      }, 200);
    }, { passive: true });
  }

  function initMobileWrap() {
    if (isHoverDevice()) return; // hover devices use Flickity / setupIndicator
    document.querySelectorAll('.product-item__image').forEach(function (div) {
      if (div.closest('.index-products')) return;
      setupMobileWrap(div);
    });
  }

  // Watch for cards added via infinite scroll or AJAX section updates.
  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.classList && node.classList.contains('product-item__image')) {
          if (isHoverDevice() && node.classList.contains('double__image')) {
            setTimeout(function () { trySetupCard(node, 0); }, 100);
          } else if (!isHoverDevice() && !node.closest('.index-products')) {
            setTimeout(function () { setupMobileWrap(node); }, 100);
          }
        }
        if (typeof node.querySelectorAll === 'function') {
          if (isHoverDevice()) {
            node.querySelectorAll('.product-item__image.double__image').forEach(function (div) {
              setTimeout(function () { trySetupCard(div, 0); }, 100);
            });
          } else {
            node.querySelectorAll('.product-item__image').forEach(function (div) {
              if (div.closest('.index-products')) return;
              setTimeout(function () { setupMobileWrap(div); }, 100);
            });
          }
        }
      });
    });
  });

  // ── Header Media – desktop video JS-controlled loop ──────────────────────
  // Browsers (Chrome + Safari) pre-scan the entire video to determine total
  // duration when the loop attribute is set, causing visible frame scrubbing
  // during the fade-in transition. Fix: omit the loop attribute and restart
  // via the ended event instead — no duration scan, no visible scrubbing.
  // Applies only to the desktop video-background element (mobile uses a
  // different code path below).

  function setupHeaderMediaVideoLoop(el) {
    if (el.dataset.hmLoopSetup) return;
    el.dataset.hmLoopSetup = '1';
    var mo = new MutationObserver(function () {
      var video = el.querySelector('video');
      if (!video || video.dataset.hmLoop) return;
      video.dataset.hmLoop = '1';
      video.loop = false;
      video.addEventListener('ended', function () {
        video.currentTime = 0;
        video.play().catch(function () {});
      });
    });
    mo.observe(el, { childList: true });
  }

  function initHeaderMediaVideoLoop() {
    document.querySelectorAll('[data-section-type="header-media"] video-background[data-video-player]').forEach(setupHeaderMediaVideoLoop);
  }

  // ── Header Media – mobile video early playback and fade-in ───────────────
  // The mobile video is in the DOM immediately with preload="auto" — no
  // IntersectionObserver gate. Play as early as possible and fade in once
  // the browser is outputting real decoded frames.
  //
  // Why inline opacity:0 (not just CSS class): the external stylesheet may
  // not be applied before the browser's native video layer renders a first
  // frame, so opacity must be set at HTML parse time via inline style.
  //
  // Why 'playing' not 'canplay': canplay fires when data is buffered but
  // before frames are being output — the browser can still show a native
  // thumbnail at that point. 'playing' fires when actual decoded frames are
  // being rendered, which is the earliest safe moment to reveal the video.
  //
  // revealVideo removes the inline opacity (which would block the CSS
  // transition via specificity) before adding the is-playing class so the
  // CSS transition animates from 0 to 1 correctly.
  //
  // Loop via 'ended' not the loop attribute — loop triggers a full-file
  // duration scan on Chrome/Safari causing visible frame scrubbing.

  function initHeaderMediaMobileVideo() {
    var video = document.querySelector('.header-media__mobile-video');
    if (!video) return;

    function revealVideo() {
      video.style.removeProperty('opacity');
      video.classList.add('is-playing');
    }

    // Already playing by the time DOMContentLoaded fires (fast device / cached)
    if (!video.paused && !video.ended && video.currentTime > 0) {
      revealVideo();
    } else {
      video.addEventListener('playing', revealVideo, { once: true });
    }

    video.addEventListener('ended', function () {
      video.play().catch(function () {});
    });

    video.play().catch(function () {});
  }

  // ── Text Read More blocks ─────────────────────────────────────────────────
  function initReadMore() {
    document.querySelectorAll('[data-read-more]').forEach(function (container) {
      if (container.dataset.readMoreInit) return;
      container.dataset.readMoreInit = '1';
      var btn = container.querySelector('[data-read-more-btn]');
      if (!btn) return;
      var span = btn.querySelector('span');
      btn.addEventListener('click', function () {
        var expanded = container.classList.toggle('is-expanded');
        if (span) span.textContent = expanded ? btn.dataset.readLessLabel : btn.dataset.readMoreLabel;
        btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
      initMobileWrap();
      initHeaderMediaVideoLoop();
      initHeaderMediaMobileVideo();
      initReadMore();
      observer.observe(document.body, { childList: true, subtree: true });
    });
  } else {
    initAll();
    initMobileWrap();
    initHeaderMediaVideoLoop();
    initHeaderMediaMobileVideo();
    initReadMore();
    observer.observe(document.body, { childList: true, subtree: true });
  }

})();

// Sibling swatch prefetch
// Prefetches sibling colorway pages + their hero images after the page settles
// so tapping a swatch feels instant, especially in iOS in-app browsers.
// Self-contained IIFE — safe to remove without touching anything else.
(function () {
  'use strict';

  var prefetched = new Set();

  function insertLink(rel, href, as) {
    var el = document.createElement('link');
    el.rel = rel;
    el.href = href;
    if (as) el.setAttribute('as', as);
    document.head.appendChild(el);
  }

  function prefetchPage(href) {
    if (prefetched.has(href)) return;
    prefetched.add(href);

    // Browser-level prefetch (well supported in Chrome/Firefox)
    insertLink('prefetch', href);

    // fetch() fallback: iOS in-app browsers ignore <link rel="prefetch">, but a
    // fetch() response lands in the HTTP cache and survives the navigation.
    // We also parse the response to extract the hero image URL.
    if (typeof fetch !== 'function' || typeof DOMParser !== 'function') return;
    try {
      fetch(href, { credentials: 'same-origin', priority: 'low' })
        .then(function (res) { return res.ok ? res.text() : null; })
        .then(function (html) {
          if (!html) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var meta = doc.querySelector('meta[property="og:image"]');
          if (!meta) return;
          var imgUrl = meta.getAttribute('content');
          if (!imgUrl || prefetched.has(imgUrl)) return;
          prefetched.add(imgUrl);
          // <link rel="preload"> so the hero image is in cache before the nav
          insertLink('preload', imgUrl, 'image');
        })
        .catch(function () {});
    } catch (e) {}
  }

  function run() {
    try {
      // Respect data-saver and 2G connections
      var conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
      if (conn && (conn.saveData || conn.effectiveType === '2g')) return;

      // Only act on product pages that actually have sibling swatches
      var swatchLinks = document.querySelectorAll('a.sibling__link:not(.sibling__link--current)');
      if (!swatchLinks.length) return;

      // Seed the set with the current URL so we never self-prefetch
      prefetched.add(location.href);
      prefetched.add(location.origin + location.pathname);

      [].forEach.call(swatchLinks, function (a) {
        if (a.href) prefetchPage(a.href);
      });
    } catch (e) {}
  }

  function schedule() {
    if (typeof requestIdleCallback === 'function') {
      requestIdleCallback(run, { timeout: 3000 });
    } else {
      setTimeout(run, 2000);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }

})();

// === Siblings_colorPopUp ===
(function () {
  'use strict';

  function init() {
    var trigger  = document.getElementById('spd-trigger-btn');
    var drawer   = document.getElementById('spd-drawer');
    var backdrop = document.getElementById('spd-backdrop');
    var closeBtn = document.getElementById('spd-close');
    if (!trigger || !drawer || !backdrop || !closeBtn) return;

    function openDrawer() {
      drawer.classList.add('spd-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      closeBtn.focus();
    }

    function closeDrawer() {
      drawer.classList.remove('spd-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      trigger.focus();
    }

    trigger.addEventListener('click', openDrawer);
    backdrop.addEventListener('click', closeDrawer);
    closeBtn.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('spd-open')) closeDrawer();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
